import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import {
    Grid, Card, Typography, FormHelperText, Button,
    TextField, FormControl, Box,
    Divider, FormControlLabel, Checkbox
} from "@mui/material";
import { Image } from 'mui-image'
import "../../static/css/login.css"
import LogoTransparent from "../../static/images/login/lynkitLogo.png"
import Logo from "../../static/images/login/Lynkgrid_warehouse.png"
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import theme, { inputClasses, cardClasses, textClasses, buttonClasses } from '../../static/styles/theme';
import { showToast } from "../../services/functions";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import GenericLoader from '../Components/Generic/GenericLoader';
import { valid_email, valid_otp_six_digit } from "../../services/validation"
import { forgotPasswordCase, verifyOTPCase, changePasswordCase, getCentralTheming } from '../../redux/actions';
import { encryptTheData } from '../../services/Api';
import { localStorageLogoutConditions } from '../../utils/services';
import { userLogin } from "../../redux/actions/Auth"
import TwoFactorAuth from './TwoFactorAuth';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';
import PinOutlinedIcon from '@mui/icons-material/PinOutlined';
export const allowedOrigins = [
    "warehouse.lynkgrid.com",
    "preprodwarehouse.lynkgrid.com",
    "warehouse-new.lynkgrid.com",
    "http://localhost",
    "localhost"
];

export function useTokenExpiry(token, setOtpToken, handleBackBtnClick) {
    useEffect(() => {
        if (!token) return; // if no token, exit early

        try {
            // Decode the JWT payload (the middle part of token)
            const payload = JSON?.parse(atob(token?.split(".")[1]));
            // Normally you'd get expiry time like this:
            const exp = payload.exp * 1000; // convert seconds to ms
            const now = Date.now();
            const remainingTime = exp - now;

            // But for testing, you hard-coded it:
            // const remainingTime = 5000; // 5 seconds

            if (remainingTime > 0) {
                // Token is still valid
                const timeout = setTimeout(() => {
                    // Once time is up → expire the token
                    showToast("Token expired, please generate again.", true);
                    setOtpToken("");       // reset token
                    handleBackBtnClick();  // reset step / go back
                }, remainingTime);

                // cleanup (clear timeout when component unmounts OR when token changes)
                return () => clearTimeout(timeout);

            } else {
                // ELSE: token already expired before you even set it
                setOtpToken("");             // reset token
                handleBackBtnClick();  // force redirect to login
            }
        } catch (err) {
            // If the token is invalid (bad format or corrupted)
            setOtpToken("");
            handleBackBtnClick();
        }
    }, [token]);
}


export function getHost(url) {
    const hostname = new URL(url).hostname;
    return allowedOrigins.includes(hostname) ? "warehouse" : hostname;
}
// export const originHost = getHost("https://veritaslogistics.lynkgrid.com/"); // for testing purpose

export const originHost = getHost(window.location.origin);
// https://whitelabling.s3.ap-south-1.amazonaws.com/demoz.tektronixit.com/themeColor
export const dynamicDomain = `https://whitelabling.s3.ap-south-1.amazonaws.com/${originHost}`
// console.log("themee", `${dynamicDomain}/themeSetting.json`)

const Login2 = (props) => {
    const dispatch = useDispatch();
    const { register, handleSubmit, formState: { errors }, getValues, reset, watch } = useForm();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [open2FaForm, setOpen2FaForm] = useState(null);
    const [otpToken, setOtpToken] = useState("")
    const [loader, setLoader] = useState('global');
    const [step, setStep] = useState(0);
    const getIconColor = (val) => (val ? theme.themeOrange : theme.themeLoginPageWhite);
    // const otpToken = parseJwt(loginResponse?.resendOtpToken)
    const handleBackBtnClick = () => {
        reset();
        setOpen2FaForm(null);
        setStep(0);
    };
    useTokenExpiry(otpToken, setOtpToken, handleBackBtnClick);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handleClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show);
    const handleMouseDownConfirmPassword = (event) => {
        event.preventDefault();
    };


    const handleLogin = (data) => {
        setLoader('login');
        let encryptedData = { payloadData: encryptTheData(data) };

        dispatch(
            userLogin(encryptedData, (response, error) => {
                setLoader('');
                if (response && response.success) {
                    // console.log('✅ Login Success:', response);
                    if (response?.twoFactorAuth === true) {
                        setOtpToken(response?.resendOtpToken)
                        setOpen2FaForm(response); // Trigger 2FA popup
                    }
                } else {
                    // console.log('Login Failed:', error);
                    showToast(error || 'Login failed', true);
                }
            })
        );
    };

    const handleResetLink = (data) => {
        setLoader('login');
        let encryptedData = { payloadData: encryptTheData(data) };
        dispatch(
            forgotPasswordCase(encryptedData, (response = {}) => {
                showToast(response.message, !response.success);
                setLoader('');
                if (response.success) {
                    reset();
                    setStep(2);
                }
            })
        );
    };

    const handleOTPVerification = (data) => {
        if (data?.confirmPassword !== data?.newPassword) {
            showToast('Password did not matched correctly', true);
            return;
        }
        setLoader('login');
        let encryptedData = { payloadData: encryptTheData(data) };
        dispatch(
            verifyOTPCase(encryptedData, (response = {}) => {
                showToast(response.message, !response.success);
                setLoader('');
                if (response.success) {
                    reset();
                    setStep(0);
                }
            })
        );
    };

    const onPressingEnterFunction = (e) => {
        let formData = getValues();
        const isEnterPressed = e.key === 'Enter';

        if (!isEnterPressed) return;

        const requiredFields = {
            0: ['email', 'password'],
            1: ['email'],
            2: ['email', 'otp', 'newPassword', 'confirmPassword'],
        };

        const isFormComplete = requiredFields[step]?.every((field) => formData?.[field]);

        if (!isFormComplete) {
            return;
        }

        const handlers = {
            0: handleLogin,
            1: handleResetLink,
            2: handleOTPVerification,
        };

        if (handlers[step]) {
            handleSubmit(handlers[step])();
        }
    };

    useEffect(() => {
        // Clear localStorage to prevent partial authentication
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        let expiryMessage = window.localStorage.getItem('TokenExpirymesssage');
        if (expiryMessage) {
            showToast(expiryMessage, true);
            localStorageLogoutConditions();
        }
        setTimeout(() => {
            setLoader('');
        }, 1000);
    }, []);

    useEffect(() => {
        fetch(`${dynamicDomain}/themeSetting.json`)
            .then((res) => {
                if (!res.ok) throw new Error('Fetch failed');
                return res.json();
            })
            .then((data) => {
                console.log('Theme color:', data);
            })
            .catch((err) => {
                console.error('Error fetching theme:', err);
            });
    }, []);
    return (
        <>
            {loader === 'global' ? (
                <Grid
                    item={true}
                    data-testid="loader"
                    container
                    direction={'column'}
                    justifyContent={'center'}
                    alignItems="center"
                    xs={12}
                    sx={{ p: 5, height: '80vh' }}
                >
                    <Grid item>
                        <GenericLoader />
                    </Grid>
                </Grid>
            ) : (
                <Grid container>
                    <Grid
                        item
                        md={7}
                        sm={12}
                        xs={12}
                        className={originHost === 'warehouse' ? 'bg-image-login' : 'bg-new'}
                        sx={{
                            height: { md: '100vh', xs: '40vh', sm: '60vh' },
                            display: 'flex',
                            alignItems: 'flex-start',
                            justifyContent: 'flex-start',
                            backgroundColor: 'black',
                            position: 'relative',
                        }}
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 24,
                                left: 30,
                                width: 142,
                                height: 90,
                                zIndex: 2,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <Image
                                data-testid="logo-company"
                                src={originHost === 'warehouse' ? LogoTransparent : `${dynamicDomain}/logo.png`}
                                alt="signin-logo"
                                width={142}
                                height={90}
                                style={{ objectFit: 'contain' }}
                            />
                        </Box>
                    </Grid>
                    <Grid
                        container
                        item
                        md={5}
                        sm={12}
                        xs={12}
                        justifyContent="center"
                        alignItems="center"
                        direction={'column'}
                        sx={{
                            height: { sm: '90vh', md: '100vh', xs: '95vh' },
                            zIndex: { sm: 1000, md: 0, xs: 1000 },
                            position: { sm: 'absolute', md: 'relative', xs: 'absolute' },
                            marginTop: { sm: '10vh', md: '0', xs: '5vh' },
                            background: 'linear-gradient(180deg, #1C1C1C 0%, #000000 52.6%, #090909 100%)'
                        }}
                    >
                        {!open2FaForm && (

                            // <Card sx={{ ml: 8, mr: 8, ...cardClasses.basic }} className="mui-custom-card">
                            <Box x={{ ml: 8, mr: 8, }}>
                                <Grid container sx={{ p: 2 }} alignItems={'center'} justifyContent={'center'}>
                                    {(step === 1 || step === 2) && (
                                        <Grid item sm={1} xs={1}>
                                            <ArrowBackIcon
                                                data-testid="arrow-back"
                                                onClick={() => {
                                                    setStep(step - 1);
                                                    reset();
                                                }}
                                                sx={{ cursor: 'pointer', color: theme.themeLoginPageWhite }}
                                            />
                                        </Grid>
                                    )}
                                    <Grid item sm={10} xs={10}>
                                        {step === 2 ? (
                                            <Typography align="center" sx={{ fontWeight: '600', fontSize: '20px', lineHeight: '27px', mr: 6, color: theme.themeLoginPageWhite }}>
                                                Verify With Code
                                            </Typography>
                                        ) : step === 1 ? (
                                            <Typography align="center" sx={{ fontWeight: '600', fontSize: '20px', lineHeight: '27px', mr: 6, color: theme.themeLoginPageWhite }}>
                                                Reset Password
                                            </Typography>
                                        ) : (
                                            <Typography align="center" sx={{ fontWeight: '600', fontSize: '20px', lineHeight: '27px' }}>
                                            </Typography>
                                        )}
                                    </Grid>
                                    <Grid item sx={{ mt: 1 }}>
                                        <Box
                                            sx={{
                                                height: 60,        // container height (less space)
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <img
                                                src={originHost === 'warehouse' ? Logo : `${dynamicDomain}/logo.png`}
                                                style={{
                                                    height: "230%",   // scale image to container height
                                                    objectFit: "contain",
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item sm={12} xs={12} sx={{ mt: 0 }}>
                                        <Typography align="center" sx={{ fontWeight: '600', fontSize: '20px', lineHeight: '27px', color: theme.themeLoginPageWhite }}>
                                            Warehouse Management System
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={12} xs={12} sx={{ mt: 3, mb: 1 }}>
                                        <Divider sx={{ color: "#70707080" }} />
                                    </Grid>
                                </Grid>
                                {loader === 'login' ? (
                                    <Grid
                                        item={true}
                                        data-testid="loader"
                                        container
                                        direction={'column'}
                                        justifyContent={'center'}
                                        alignItems="center"
                                        xs={12}
                                        sx={{ p: 4 }}
                                    >
                                        <Grid item>
                                            <GenericLoader />
                                        </Grid>
                                    </Grid>
                                ) :
                                    (
                                        <>

                                            {step === 2 && (
                                                <Grid
                                                    sx={{ pl: 8, pr: 8, mt: 2 }}
                                                    container
                                                    direction="row"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                >
                                                    <TextField
                                                        variant="outlined"
                                                        type="number"
                                                        placeholder="Enter Your OTP"
                                                        error={!!errors.otp}
                                                        helperText={errors.otp ? "Please enter valid OTP (must be 6 digits)" : ""}
                                                        // label removed so no floating label appears ("OTP" removed)
                                                        data-testid="otp-input"
                                                        fullWidth
                                                        size="small"
                                                        InputLabelProps={{ shrink: false }}
                                                        sx={{
                                                            "& .MuiOutlinedInput-root": {
                                                                backgroundColor: "#1e1e1e",
                                                                borderRadius: "0px !important",
                                                                boxShadow: "none !important",
                                                                "&:hover": { boxShadow: "none !important" },
                                                                "&.Mui-focused": { boxShadow: "none !important" },
                                                                "& fieldset": {
                                                                    borderColor: "transparent !important",
                                                                    borderWidth: "0px !important",
                                                                    borderRadius: "0px !important"
                                                                },
                                                                "&:hover fieldset": {
                                                                    borderColor: "transparent !important",
                                                                    borderWidth: "0px !important",
                                                                    borderRadius: "0px !important"
                                                                },
                                                                "&.Mui-focused fieldset": {
                                                                    borderColor: "transparent !important",
                                                                    borderWidth: "0px !important",
                                                                    borderRadius: "0px !important"
                                                                },
                                                            },
                                                            "& .MuiOutlinedInput-notchedOutline": {
                                                                borderColor: "transparent !important",
                                                                borderWidth: "0px !important",
                                                                borderRadius: "0px !important",
                                                            },
                                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                                borderColor: "transparent !important",
                                                                borderWidth: "0px !important",
                                                                borderRadius: "0px !important",
                                                            },
                                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                borderColor: "transparent !important",
                                                                borderWidth: "0px !important",
                                                                borderRadius: "0px !important",
                                                            },
                                                            "& .MuiInputBase-input::placeholder": {
                                                                color: theme.themeLoginPageWhite,
                                                                opacity: 1,
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                paddingLeft: "8px",
                                                                color: theme.themeWhite,
                                                            },
                                                            "& input:-webkit-autofill": {
                                                                WebkitBoxShadow: "0 0 0 1000px #1e1e1e inset",
                                                                WebkitTextFillColor: theme.themeWhite,
                                                            },
                                                        }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <LockOutlinedIcon sx={{ color: getIconColor(watch("otp")) }} />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                        onKeyDown={(e) => onPressingEnterFunction(e)}
                                                        {...register("otp", { required: true, validate: valid_otp_six_digit })}
                                                    />
                                                </Grid>
                                            )}


                                            <Grid
                                                sx={{ pl: 8, pr: 8, mt: 2 }}
                                                container
                                                direction={'row'}
                                                alignItems={'center'}
                                                justifyContent={'center'}
                                            >
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    data-testid="email-input"
                                                    type="email"
                                                    placeholder="Enter your email / username"
                                                    error={!!errors.email}
                                                    helperText={errors.email ? "Please enter valid email" : ""}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <MailOutlineIcon sx={{ color: getIconColor(watch("email")) }} />
                                                            </InputAdornment>
                                                        ),
                                                        notched: false // To prevent notch visual
                                                    }}
                                                    InputLabelProps={{ shrink: false }}
                                                    sx={{
                                                        "& .MuiOutlinedInput-root": {
                                                            backgroundColor: "#1e1e1e",
                                                            borderRadius: "0px !important",
                                                            boxShadow: "none !important",
                                                            "&:hover": { boxShadow: "none !important" },
                                                            "&.Mui-focused": { boxShadow: "none !important" },
                                                            "& fieldset": {
                                                                borderColor: "transparent !important",
                                                                borderWidth: "0px !important",
                                                                borderRadius: "0px !important"
                                                            },
                                                            "&:hover fieldset": {
                                                                borderColor: "transparent !important",
                                                                borderWidth: "0px !important",
                                                                borderRadius: "0px !important"
                                                            },
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "transparent !important",
                                                                borderWidth: "0px !important",
                                                                borderRadius: "0px !important"
                                                            },
                                                        },
                                                        "& .MuiOutlinedInput-notchedOutline": {
                                                            borderColor: "transparent !important",
                                                            borderWidth: "0px !important",
                                                            borderRadius: "0px !important",
                                                        },
                                                        "&:hover .MuiOutlinedInput-notchedOutline": {
                                                            borderColor: "transparent !important",
                                                            borderWidth: "0px !important",
                                                            borderRadius: "0px !important",
                                                        },
                                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                            borderColor: "transparent !important",
                                                            borderWidth: "0px !important",
                                                            borderRadius: "0px !important",
                                                        },
                                                        "& .MuiInputBase-input::placeholder": {
                                                            color: theme.themeLoginPageWhite,
                                                            opacity: 1,
                                                        },
                                                        "& .MuiInputBase-input": {
                                                            paddingLeft: "8px",
                                                            color: theme.themeWhite,
                                                        },
                                                        "& input:-webkit-autofill": {
                                                            WebkitBoxShadow: "0 0 0 1000px #1e1e1e inset",
                                                            WebkitTextFillColor: theme.themeWhite,
                                                        },
                                                    }}
                                                    {...register("email", { required: true, validate: valid_email })}
                                                    onKeyDown={(e) => onPressingEnterFunction(e)}
                                                />
                                            </Grid>


                                            {(step === 0 || step === 2) && (
                                                <Grid
                                                    sx={{ pl: 8, pr: 8, mt: 2 }}
                                                    container
                                                    direction="column"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                >

                                                    {/* PASSWORD FIELD */}
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        type={showPassword ? "text" : "password"}
                                                        placeholder={step === 2 ? "Enter new password" : "Enter your password"}
                                                        error={!!errors.password}
                                                        data-testid="password-input"
                                                        // InputLabelProps={{ shrink: false }}
                                                        sx={{
                                                            "& .MuiOutlinedInput-root": {
                                                                backgroundColor: "#1e1e1e",
                                                                borderRadius: "0px !important",
                                                                boxShadow: "none !important",
                                                                "&:hover": { boxShadow: "none !important" },
                                                                "&.Mui-focused": { boxShadow: "none !important" },
                                                                "& fieldset": {
                                                                    borderColor: "transparent !important",
                                                                    borderWidth: "0px !important",
                                                                    borderRadius: "0px !important"
                                                                },
                                                                "&:hover fieldset": {
                                                                    borderColor: "transparent !important",
                                                                    borderWidth: "0px !important",
                                                                    borderRadius: "0px !important"
                                                                },
                                                                "&.Mui-focused fieldset": {
                                                                    borderColor: "transparent !important",
                                                                    borderWidth: "0px !important",
                                                                    borderRadius: "0px !important"
                                                                },
                                                            },
                                                            "& .MuiOutlinedInput-notchedOutline": {
                                                                borderColor: "transparent !important",
                                                                borderWidth: "0px !important",
                                                                borderRadius: "0px !important",
                                                            },
                                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                                borderColor: "transparent !important",
                                                                borderWidth: "0px !important",
                                                                borderRadius: "0px !important",
                                                            },
                                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                borderColor: "transparent !important",
                                                                borderWidth: "0px !important",
                                                                borderRadius: "0px !important",
                                                            },
                                                            "& .MuiInputBase-input::placeholder": {
                                                                color: theme.themeLoginPageWhite,
                                                                opacity: 1,
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                paddingLeft: "8px",
                                                                color: theme.themeWhite,
                                                            },
                                                            "& input:-webkit-autofill": {
                                                                WebkitBoxShadow: "0 0 0 1000px #1e1e1e inset",
                                                                WebkitTextFillColor: theme.themeWhite,
                                                            },
                                                        }}
                                                        InputProps={{
                                                            disableUnderline: true,
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <LockOutlinedIcon sx={{ color: getIconColor(watch(step === 2 ? "newPassword" : "password")) }} />
                                                                </InputAdornment>
                                                            ),
                                                            ...(step === 2
                                                                ? {
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton
                                                                                aria-label="toggle password visibility"
                                                                                onClick={handleClickShowPassword}
                                                                                onMouseDown={handleMouseDownPassword}
                                                                                edge="end"
                                                                                data-testid="show-password"
                                                                                sx={{ color: theme.themeLoginPageWhite }}
                                                                            >
                                                                                {showPassword ? (
                                                                                    <VisibilityOff sx={{ color: getIconColor(watch("newPassword")) }} />
                                                                                ) : (
                                                                                    <Visibility sx={{ color: getIconColor(watch("newPassword")) }} />
                                                                                )}
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    )
                                                                }
                                                                : {})
                                                        }}
                                                        {...register(step === 2 ? "newPassword" : "password", { required: true })}
                                                        onKeyDown={onPressingEnterFunction}
                                                    />

                                                    {/* ERROR MESSAGE */}
                                                    {errors.password && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 1 }}>
                                                            Please enter {step === 2 ? "new" : ""} password
                                                        </Typography>
                                                    )}

                                                    {/* SHOW PASSWORD (step 0 only) + FORGOT PASSWORD ROW */}
                                                    <Grid
                                                        container
                                                        sx={{
                                                            width: {
                                                                xs: "90%",
                                                                sm: "90%",
                                                                md: "90%",
                                                            },
                                                            mt: 1,
                                                        }}
                                                        alignItems="center"
                                                        justifyContent="space-between"
                                                    >
                                                        {step === 0 && (
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={showPassword}
                                                                        onChange={handleClickShowPassword}
                                                                        sx={{
                                                                            color: theme.themeLoginPageWhite,
                                                                            "&.Mui-checked": { color: theme.themeOrange },
                                                                        }}
                                                                    />
                                                                }
                                                                label={
                                                                    <Typography sx={{ color: theme.themeOrange, ...textClasses.normalText }}>
                                                                        Show Password
                                                                    </Typography>
                                                                }
                                                            />
                                                        )}
                                                        {step === 0 && (
                                                            <Typography
                                                                sx={{
                                                                    ...textClasses.normalText,
                                                                    color:
                                                                        originHost === 'warehouse'
                                                                            ? theme.themeGray
                                                                            : originHost === 'demoz.tektronixit.com'
                                                                                ? '#004846'
                                                                                : '#84155a',
                                                                    cursor: 'pointer',
                                                                }}
                                                                data-testid="forgot-password"
                                                                onClick={() => {
                                                                    setStep(1);
                                                                    reset();
                                                                }}
                                                            >
                                                                Forgot Password ?
                                                            </Typography>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            )}
                                            {step === 2 && (
                                                <Grid
                                                    sx={{ pl: 8, pr: 8, mt: 2 }}
                                                    container
                                                    direction="row"
                                                    alignItems="center"
                                                    justifyContent="center"
                                                >
                                                    <TextField
                                                        variant="outlined"
                                                        type={showConfirmPassword ? "text" : "password"}
                                                        placeholder="Enter Confirm Password"
                                                        error={!!errors.confirmPassword}
                                                        data-testid="confirm-password-input"
                                                        fullWidth
                                                        size="small"
                                                        InputLabelProps={{ shrink: false }}
                                                        sx={{
                                                            "& .MuiOutlinedInput-root": {
                                                                backgroundColor: "#1e1e1e",
                                                                borderRadius: "0px !important",
                                                                boxShadow: "none !important",
                                                                "&:hover": { boxShadow: "none !important" },
                                                                "&.Mui-focused": { boxShadow: "none !important" },
                                                                "& fieldset": {
                                                                    borderColor: "transparent !important",
                                                                    borderWidth: "0px !important",
                                                                    borderRadius: "0px !important"
                                                                },
                                                                "&:hover fieldset": {
                                                                    borderColor: "transparent !important",
                                                                    borderWidth: "0px !important",
                                                                    borderRadius: "0px !important"
                                                                },
                                                                "&.Mui-focused fieldset": {
                                                                    borderColor: "transparent !important",
                                                                    borderWidth: "0px !important",
                                                                    borderRadius: "0px !important"
                                                                },
                                                            },
                                                            "& .MuiOutlinedInput-notchedOutline": {
                                                                borderColor: "transparent !important",
                                                                borderWidth: "0px !important",
                                                                borderRadius: "0px !important",
                                                            },
                                                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                                                borderColor: "transparent !important",
                                                                borderWidth: "0px !important",
                                                                borderRadius: "0px !important",
                                                            },
                                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                borderColor: "transparent !important",
                                                                borderWidth: "0px !important",
                                                                borderRadius: "0px !important",
                                                            },
                                                            "& .MuiInputBase-input::placeholder": {
                                                                color: theme.themeLoginPageWhite,
                                                                opacity: 1,
                                                            },
                                                            "& .MuiInputBase-input": {
                                                                paddingLeft: "8px",
                                                                color: theme.themeWhite,
                                                            },
                                                            "& input:-webkit-autofill": {
                                                                WebkitBoxShadow: "0 0 0 1000px #1e1e1e inset",
                                                                WebkitTextFillColor: theme.themeWhite,
                                                            },
                                                        }}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <LockOutlinedIcon sx={{ color: getIconColor(watch("confirmPassword")) }} />
                                                                </InputAdornment>
                                                            ),
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        aria-label="toggle password visibility"
                                                                        onClick={handleClickShowConfirmPassword}
                                                                        onMouseDown={handleMouseDownConfirmPassword}
                                                                        edge="end"
                                                                        data-testid="show-password"
                                                                        sx={{ color: theme.themeLoginPageWhite }}
                                                                    >
                                                                        {showConfirmPassword ? <VisibilityOff sx={{ color: getIconColor(watch("confirmPassword")) }} /> : <Visibility sx={{ color: getIconColor(watch("confirmPassword")) }} />}
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                        {...register("confirmPassword", { required: true })}
                                                        onKeyDown={(e) => onPressingEnterFunction(e)}
                                                    />

                                                    {errors.confirmPassword && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 1 }}>
                                                            Please enter confirm password
                                                        </Typography>
                                                    )}
                                                </Grid>
                                            )}
                                            <Grid container item sx={{ pl: 8, pr: 8, mt: 2, mb: 4 }} justifyContent="center">

                                                {/* SIGN IN / SEND OTP / VERIFY OTP BUTTON */}
                                                <Button
                                                    fullWidth
                                                    size="medium"
                                                    data-testid={
                                                        step === 0 ? "signin-btn" :
                                                            step === 1 ? "resetlink-btn" :
                                                                "verifyotp-btn"
                                                    }
                                                    role="signInUserButton"
                                                    onClick={
                                                        step === 0
                                                            ? handleSubmit(handleLogin)
                                                            : step === 1
                                                                ? handleSubmit(handleResetLink)
                                                                : handleSubmit(handleOTPVerification)
                                                    }
                                                    sx={{
                                                        backgroundColor: "#1e1e1e",
                                                        color: theme.themeOrange,
                                                        textTransform: "none",
                                                        fontSize: "18px",
                                                        fontWeight: 900,
                                                        paddingY: "10px",
                                                        borderRadius: "2px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        gap: 1,
                                                        "&:hover": {
                                                            backgroundColor: "#2a2a2a",
                                                        },
                                                    }}
                                                >
                                                    {step === 0 ? (
                                                        <Person2OutlinedIcon sx={{ color: theme.themeOrange }} />
                                                    ) : (
                                                        <PinOutlinedIcon sx={{ color: theme.themeOrange }} />
                                                    )}
                                                    {step === 0 ? "Sign In" : step === 1 ? "Send OTP" : "Verify OTP"}
                                                </Button>

                                                {/* OR DIVIDER */}
                                                <Grid container alignItems="center" justifyContent="center" sx={{ mt: 3 }}>
                                                    <Grid item xs={5}>
                                                        <Divider sx={{ color: "#70707080" }} />
                                                    </Grid>

                                                    <Grid item xs={2}>
                                                        <Typography
                                                            align="center"
                                                            sx={{ color: theme.themeLoginPageWhite, ...textClasses.normalText }}
                                                        >
                                                            Or
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={5}>
                                                        <Divider sx={{ color: "#70707080" }} />
                                                    </Grid>
                                                </Grid>

                                                {/* CONTACT US */}
                                                {/* CONTACT US */}
                                                <Grid container justifyContent="center" sx={{ mt: 2 }}>
                                                    <Typography
                                                        sx={{
                                                            color: theme.themeLoginPageWhite,
                                                            fontSize: "14px",
                                                            textAlign: "center",   // center align text
                                                            width: "100%",         // ensures the text wraps properly
                                                        }}
                                                    >
                                                        Don’t have an account?
                                                        <br />
                                                        <Box
                                                            component="a"
                                                            href="https://www.lynkit.in/ContactUs"
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            sx={{
                                                                color: theme.themeOrange,
                                                                fontWeight: 600,
                                                                cursor: "pointer",
                                                                display: "inline-block",
                                                                textDecoration: "none",
                                                                "&:hover": {
                                                                    color: theme.themeOrange,
                                                                    textDecoration: "underline"
                                                                },
                                                                mt: 0.2,
                                                            }}
                                                        >
                                                            Contact Us
                                                        </Box>
                                                    </Typography>
                                                </Grid>


                                            </Grid>

                                        </>
                                    )}
                            </Box>
                            // </Card>
                        )}
                        {open2FaForm && (
                            <TwoFactorAuth
                                open2FaForm={open2FaForm}
                                setOpen2FaForm={setOpen2FaForm}
                                handleBackBtnClick={handleBackBtnClick}
                                getValues={getValues}
                                dispatch={dispatch}
                            />
                        )}
                    </Grid>
                </Grid>
            )}
            <ToastContainer position="bottom-center" autoClose={false} closeOnClick={false} />
        </>
    );
};

export default Login2;